import type { SelectItemProps, SelectItemTextProps } from '@base-ui/react';

import { Select as BaseSelect } from '@base-ui/react';

import { clsxs } from '~/styles/utils';

import { Icon } from '../../Icon/Icon';
import { itemIndicatorStyle, itemStyle } from '../form.css';

type Props = Omit<SelectItemProps, 'children'> & Pick<SelectItemTextProps, 'children'>;

export const SelectItem = ({ children, ...delegated }: Props) => {
  return (
    <BaseSelect.Item {...delegated} className={clsxs(itemStyle, delegated.className)}>
      <BaseSelect.ItemText>{children}</BaseSelect.ItemText>
      <BaseSelect.ItemIndicator className={itemIndicatorStyle}>
        <Icon name="Check" />
      </BaseSelect.ItemIndicator>
    </BaseSelect.Item>
  );
};
